import React from 'react';
import { Flex, FlexProps } from 'rebass';
import ModalHeader from './ModalHeader';
import Icon from '../Icon/Icon';

type ModalProps = FlexProps & {
  title?: string | JSX.Element;
  children?: React.ReactNode;
  onClose?: () => void;
};

const Modal = ({ title, children, ...props }: ModalProps): JSX.Element => (
  <Flex
    size="100%"
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10,
      '&::before': {
        content: "''",
        width: '100%',
        height: '100%',
        position: 'absolute',
        bg: 'portal',
        opacity: '0.45',
      },
    }}
    // onClick={props.onClose}
  >
    <Flex
      {...(props as any)}
      sx={{
        position: 'relative',
        width: ['100%', 'modalMax'],
        minWidth: ['300px', 'modalMin'],
        maxWidth: ['100%', '70%', '90%'],
        height: ['100%', 'auto', 'auto'],
        maxHeight: ['100%', '95%'],
        flexDirection: 'column',
        bg: 'modal',
        borderRadius: [0, 'default'],
        pointerEvents: 'all',
        ...props.sx,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close */}
      {props.onClose && (
        <Flex
          size={50}
          // bg="purple"
          sx={{
            position: 'absolute',
            top: 1,
            right: [1, 1, undefined],
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              cursor: 'pointer',
            },
            '&:hover svg': {
              fill: 'primary',
            },
          }}
          onClick={props.onClose}
        >
          <Icon icon="x" size="32" />
        </Flex>
      )}

      {title && <ModalHeader title={title} />}

      {children}
    </Flex>
  </Flex>
);

export default Modal;
